// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Log } from '@probe.gl/log';
const defaultLogger = new Log({ id: 'deck' });
export default defaultLogger;
//# sourceMappingURL=log.js.map